import { render, staticRenderFns } from "./tag-nodata-template.vue?vue&type=template&id=4acf12e3&scoped=true"
import script from "./tag-nodata-template.vue?vue&type=script&lang=js"
export * from "./tag-nodata-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acf12e3",
  null
  
)

export default component.exports